export class UpdatePageSpeedSettingsError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "UpdatePageSpeedSettingsError";
  }
}
